import { stdObject } from "../../../../data/types/stdObject";
import { callDocuments } from "../../../../services/callDocuments";
import { getDaysOfMonth } from "../../../../utils/getCurrentDate";
import { getNextDate } from "../../../../utils/getNextDate";

const getNextMonth = (date: string, next = false) => {
  let tempDate = date.split("-").map((e: string) => Number(e));

  if (next) {
    tempDate[1]++;
    if (tempDate[1] > 12) {
      tempDate[1] = 1;
      tempDate[0]++;
    }
  } else {
    tempDate[1]--;
    if (tempDate[1] < 1) {
      tempDate[1] = 12;
      tempDate[0]--;
    }
  }

  return [
    ...tempDate,
    `${tempDate[0]}-${tempDate[1] < 10 ? "0" + tempDate[1] : tempDate[1]}`,
  ];
};

export const startCalendar = async (current: string, dataPack: stdObject) => {
  const { user, logoutAction, setCalDocsList, setCalendarDays } = dataPack;
  const currDate = current.split("-").map((e: string) => Number(e));
  let prevMonth = getNextMonth(current, false);
  let nextMonth = getNextMonth(current, true);

  let serviceDocsList: Array<stdObject> = await callDocuments({
    user: [1, 5].includes(user.TEC) ? user.CODUSU : "",
    code: "sev",
    ser: user.CODSUC ?? 0,
    warehouse: user.ALMSUC,
    dateCode: "FEC2",
    startDate: `${prevMonth[2]}-24`,
    days: 45,
    logoutAction,
  });
  setCalDocsList([
    ...serviceDocsList.map((e: stdObject) => {
      return { type: "SEV", data: e };
    }),
  ]);

  let days = getDaysOfMonth({ year: currDate[0], month: currDate[1] });

  setCalendarDays({
    ...days,
    previous: prevMonth[2],
    current,
    next: nextMonth[2],
  });
  changeTableScroll();
};

const formatDate = (date: Date) => {
  const yy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
};

export const getWeekStart = (dateStr: string) => {
  const [y, m, d] = dateStr.split("-").map((e: string) => Number(e));
  const date = new Date(y, m - 1, d);
  date.setDate(date.getDate() - date.getDay());
  return formatDate(date);
};

export const getRowWeekStart = (
  current: string,
  dayWeek: number,
  rowIndex: number,
) => {
  const [y, m] = current.split("-").map((e: string) => Number(e));
  const date = new Date(y, m - 1, 1 + rowIndex * 7 - dayWeek);
  return formatDate(date);
};

export const isInWeek = (cellId: string, weekStart: string) => {
  if (!weekStart || !cellId) return false;
  const weekEnd = getNextDate(weekStart, 6);
  return cellId >= weekStart && cellId <= weekEnd;
};

const changeTableScroll = () => {
  try {
    //  document.getElementById("tableBox").scrollTop = scrollPosition;
  } catch (error) {
    console.log("changeTableScroll error: ", error);
  }
};
